import React from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { IProduct } from 'src/types/products';
import { getTranslate } from 'src/utils/formatter';

interface IProps {
  exclusions: IProduct['exclusions'];
}

const CartProductExclusions: React.FC<IProps> = (props: IProps): JSX.Element | null => {
  let { exclusions } = props;
  exclusions = exclusions.filter((exclusion) => exclusion.selected);

  if (!exclusions.length) return null;

  return (
    <div className="d-flex flex-column">
      <p className="color-gray text-uppercase text-size-12 text-md-size-8 mb-2 family-regular">
        {localeStore.t('Exclusions')}
      </p>
      {exclusions.map((exclusion) => (
        <p
          key={exclusion.id}
          className={`mb-2 family-semibold text-size-16 text-md-size-14 color-darkgray ${
            exclusion.error ? 'exclusion-invalid' : ''
          }`}
        >
          {getTranslate(exclusion.name)}
        </p>
      ))}
    </div>
  );
};

export default React.memo(CartProductExclusions);
